import React, {FormEvent, useEffect, useState} from "react";
import {
    Button,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    SelectChangeEvent,
    TextField
} from "@mui/material";
import {useLoaderData, useParams} from "react-router-dom";
import {Reg} from "./Registration";
import Box from "@mui/material/Box";
import axios from "axios";
import {DataGrid, GridColDef} from "@mui/x-data-grid";
import {CustomToolbar} from "./components/CustomToolbar";
import {getAllDonations, saveDonation} from "./Donation";

export interface GoblinStamps {
    id?: number,
    player?: { playerId: number, name: string, characterId: number },
    playerId?: number,
    amount: number,
    note: string
}

const columns: GridColDef[] = [
    {
        field: 'player',
        headerName: 'Player',
        width: 150,
        valueGetter: (params) => (params.row.player.name)
        /*renderCell: (params) => (
            <Link to={'/pcs/' + params.row.registration.characterId}>{params.row.registration.name}</Link>
        )*/
    },
    {field: 'amount', headerName: "AMT", headerAlign: "center", type: "number"},
    {field: 'note', headerName: "Note", headerAlign: "center"}
]

export async function getAllGoblinStamps(eventId: number): Promise<GoblinStamps[]> {
    const apiEndpoint = `/api/events/${eventId}/stamps`
    return await axios.get(apiEndpoint).then(({data}) => {
        return data as GoblinStamps[]
    })
}

export async function saveGoblinStamps(entry: GoblinStamps, eventId: number) {
    const apiEndpoint = `/api/events/${eventId}/pcs/` + entry.playerId + '/stamps'
    return await axios.post(apiEndpoint, entry).then(({data}) => {
        return data
    })
}

export default function Stamps() {
    const {eventId} = useParams<{eventId: string}>()
    const eid = parseInt(eventId!)
    const [registrations, setReg] = useState(useLoaderData() as Reg[]);
    const [playerId, setPlayerId] = useState("");
    const [stamps, setStamps] = useState(0);
    const [reason, setReason] = useState("")
    const [stampList, setStampList] = useState([] as GoblinStamps[])

    useEffect(() => {
        getAllGoblinStamps(eid).then(data => setStampList(data))
        console.log(playerId + ":" + stamps + ":" + reason)
    }, [])

    const onPlayerIdChange = (event: SelectChangeEvent) => {
        console.log("changing player to " + event.target.value)
        setPlayerId(event.target.value)
    }

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        const sub: GoblinStamps = {
            playerId: parseInt(playerId),
            amount: parseInt(event.target.stamps.value),
            note: event.target.note.value

        }
        saveGoblinStamps(sub, eid).then((d) => {
            getAllGoblinStamps(eid).then(data => setStampList(data))
            setPlayerId("")
            event.target.reset();
        })
    }

    return <React.Fragment>
        <h2>Stamp Transactions</h2>
        <Box component="form" noValidate onSubmit={handleSubmit}>
            <Paper elevation={2}>
                <Grid container spacing={1} p={1}>
                    <Grid item xs={12} sm={6} md={4} p={1}>
                        <Paper elevation={2} sx={{p: 1}}>
                            <FormControl fullWidth>
                                <InputLabel id="player-select-label">Player</InputLabel>
                                <Select
                                    labelId="player-select-label"
                                    id="player-select"
                                    label="Player"
                                    required={true}
                                    value={playerId}
                                    onChange={onPlayerIdChange}
                                >
                                    {registrations.sort((a, b) => {
                                        return (a.name < b.name) ? -1 : 1
                                    }).map((r) => {
                                        return <MenuItem key={r.playerId} value={r.playerId}>{r.name}</MenuItem>
                                    })}

                                </Select>
                            </FormControl>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} p={1}>
                        <Paper elevation={2} sx={{p: 1}}>
                            <FormControl fullWidth>
                                <TextField
                                    id="stamps"
                                    label="Stamps"
                                    type="number"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </FormControl>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} p={1}>
                        <Paper elevation={2} sx={{p: 1}}>
                            <FormControl fullWidth>
                                <TextField
                                    id="note"
                                    label="Note"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    multiline
                                    maxRows={4}
                                />
                            </FormControl>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} height={"100%"} p={1}>
                        <Paper elevation={2} sx={{p: 1}}>
                            <Button variant="contained" type="submit" onClick={() => {
                            }}
                                    sx={{
                                        height: "100%",
                                        width: "100%",
                                        stretch: "100%"
                                    }}>Submit</Button>
                        </Paper>
                    </Grid>
                </Grid>
            </Paper>
        </Box>
        <Paper elevation={2} sx={{p: 1, mt: 2}}>
            <DataGrid slots={{toolbar: CustomToolbar}}
                      localeText={{toolbarColumns: "", toolbarFilters: "", toolbarDensity: "", toolbarExport: ""}}
                      rows={stampList}
                      disableRowSelectionOnClick
                      columns={columns}
                      autoHeight={true}
                      density={"compact"}
                      disableColumnMenu={true}
                      getRowId={row => {
                          return row.id
                      }}
            />
        </Paper>
    </React.Fragment>
}